import React from 'react';

import styles from './ConfigureAddressCollectionHeader.module.less';

const ConfigureAddressCollectionHeader: React.FC = () => (
  <div>
    <h1 className={styles.title}>Edit Your Magic Link</h1>
    <p>
      Add a photo, message, even your date. Or leave as-is. If you edit later, guests will always
      see the most updated version.
    </p>
  </div>
);

export default ConfigureAddressCollectionHeader;



// WEBPACK FOOTER //
// ./src/components/manage/guestlist/addressCollection/ConfigureAddressCollectionHeader/ConfigureAddressCollectionHeader.tsx